import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

/* eslint-disable */
export default new Vuex.Store({
  state: {
    isSubmitting: false,
    crmId: '',
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    dob: '',
    gender: '',
    postcode: '',
    offers: [],
    firstToKnow: '',
    interests: [],
    selectedStore: '',
    selectedStoreName: '',
  },
  getters: {
    getCrmId: state => {
      return state.crmId;
    },
    getFirstname: state => {
      return state.firstName;
    },
    getLastname: state => {
      return state.lastName;
    },
    getEmail: state => {
      return state.email;
    },
    getMobile: state => {
      return state.mobile;
    },
    getDob: state => {
      return state.dob;
    },
    getGender: state => {
      return state.gender;
    },
    getPostcode: state => {
      return state.postcode;
    },
    getOffers: state => {
      return state.offers;
    },
    getFirstToKnow: state => {
      return state.firstToKnow;
    },
    getInterests: state => {
      return state.interests;
    },
    getSelectedStore: state => {
      return state.selectedStore;
    },
    getSelectedStoreName: state => {
      return state.selectedStoreName;
    },
  },
  mutations: {
    setInitialData(state, fetched) {
      const initialData = fetched.data;
      const page = fetched.page;

      console.log(initialData);

      if(page === 'confirm') {
        console.log('setting ', page);
        state.crmId = initialData.AccountCode;
        state.firstName = 'heyy';
        state.lastName = initialData.LastName;
        state.email = initialData.email;
        state.mobile = initialData.mobile;
        state.dob = initialData.dob;
        state.gender = initialData.gender;
        state.postcode = initialData.postcode;
        state.offers = initialData.offers;
        state.firstToKnow = initialData.firstToKnow;
        state.interests = initialData.interests;
        state.selectedStore = initialData.closestStore;
      } else {
        state.crmId = initialData.AccountCode;
        state.firstName = initialData.firstName;
        state.lastName = initialData.lastName;
        // state.email = initialData.email;
        // state.mobile = initialData.mobile;
        // state.dob = initialData.dob;
        // state.gender = initialData.gender;
        // state.postcode = initialData.postcode;
        // state.offers = initialData.offers;
        // state.firstToKnow = initialData.firstToKnow;
        // state.interests = initialData.interests;
        // state.selectedStore = initialData.closestStore;
      }
    },
    setSubmitting(state, status) {
      state.isSubmitting = status;
    },
    setCrmId(state, crmId) {
      state.crmId = crmId;
    },
    setFirstname(state, firstname) {
      state.firstName = firstname;
    },
    setLastname(state, lastname) {
      state.lastName = lastname;
    },
    setEmail(state, email) {
      state.email = email;
    },
    setMobile(state, mobile) {
      state.mobile = mobile;
    },
    setDob(state, dob) {
      state.dob = dob;
    },
    setGender(state, gender) {
      state.gender = gender;
    },
    setPostcode(state, postcode) {
      state.postcode = postcode;
    },
    setOffers(state, offers) {
      state.offers = offers;
    },
    setFirstToKnow(state, firstToKnow) {
      state.firstToKnow = firstToKnow;
    },
    setInterests(state, interests) {
      state.interests = interests;
    },
    setSelectedStore(state, selectedStore) {
      state.selectedStore = selectedStore;
    },
    setSelectedStoreName(state, selectedStoreName) {
      state.selectedStoreName = selectedStoreName;
    },
  },
});
/* eslint-enable */
